import { useQuery } from '@tanstack/react-query';
import * as roleServices from 'services/roles-security';

export const useGetAvailablePermissions = (options = {}) => {
  return useQuery({
    queryKey: ['get-available-permissions'],
    queryFn: async () => {
      const response = await roleServices.getAvailablePermissions();

      return response?.data?.permissions;
    },
    staleTime: Infinity,
    ...options,
  });
};
